import { Navigate, Outlet } from "react-router-dom";
import useAuth from "@/hooks/useAuth";
import roleHomePath from "@/routing/roleHomePath";

function ProtectedRoute() {
  const { session, isAuthenticated, isInitializing } = useAuth();

  if (isInitializing) {
    return null;
  }

  if (!isAuthenticated || !session) {
    return <Navigate to="/signin" replace />;
  }

  if (session.role !== "HOST") {
    return <Navigate to={roleHomePath(session.role)} replace />;
  }

  return <Outlet />;
}

export default ProtectedRoute;
